module.exports = __webpack_public_path__ + "img/jibble-logo.35bb6d48.png";